// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"index_dropdown_16R1Q","icon":"index_icon_2iFCF","title":"index_title_3buwC"};